import { render, staticRenderFns } from "./Index_User.vue?vue&type=template&id=c258b652&scoped=true&"
import script from "./Index_User.vue?vue&type=script&lang=js&"
export * from "./Index_User.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c258b652",
  null
  
)

export default component.exports